import { useExportProductQrCode } from "~/gen/api"
import { useAuth } from "~/store/auth-context"
import { downloadFile } from "~/utils/downloadFile"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useExportProductQrCodeMutation = () => {
  const { user } = useAuth()

  return useExportProductQrCode({
    mutation: {
      onSuccess: (response) => {
        downloadFile(
          response.data,
          `${user?.organization?.slug.toLowerCase()}-product-qr-code_${new Date().toJSON().slice(0, 10)}.csv`,
          "text/csv"
        )

        showSuccessNotification({
          title: "Success",
          message: "Product QR Code exported",
        })
      },
      onError: (error) => {
        showAxiosError({
          notificationTitle: "Error",
          notificationMessage: error.message,
          showNotification: true,
          error,
        })
      },
    },
  })
}
